import React, { Component } from 'react';
import { notification, Modal } from 'antd/lib';
import FormDireccionReal from './FormDireccionReal';
import { withApollo, graphql, compose } from 'react-apollo';

import actualizarDireccion from '../../../graphql/mutations/contravenciones/actualizarDireccion.graphql';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsExpedientes from '../../../actions/expediente';
import * as actionsContraventores from '../../../actions/contraventores';
import * as actionsMain from '../../../actions/main';

@compose(graphql(actualizarDireccion, { name: 'actualizarDireccion' }))
class ModalSancion extends Component {
  state = {
    articulosParaSancionar: [],
    cantidadJus: 0,
    montoSancion: 0,
    montoAdicional: 0,
  };

  handleOk = datos => {
    this.props
      .actualizarDireccion({
        variables: {
          _id: this.props.contraventor._id,
          nuevaDireccion: datos,
        },
      })
      .then(res => {
        console.log('Recibi...');
        console.log(res);

        if (res.data.actualizarDireccion) {
          this.props.actionsExpedientes.actualizarContraventor(
            res.data.actualizarDireccion
          );

          notification.success({
            message: 'Direccion del Contraventor Actualizada',
            description: 'La direccion se logró actualizar correctamente.',
          });

          this.props.ocultarModalDireccion();
        }
      })
      .catch(err => {
        console.log('ERROR');
        console.log(err);

        Modal.error({
          title: 'Error a la hora de actualizar la direccion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  render() {
    return (
      <div>
        <Modal
          title="Actualizar Direccion"
          visible={this.props.visibleActualizarDireccion}
          onCancel={this.props.ocultarModalDireccion}
          onOk={this.handleOk}
          width={800}
          style={{ width: 600 }}
          footer={[]}
        >
          <FormDireccionReal
            onSubmit={this.handleOk}
            datos={
              this.props.contraventor && this.props.contraventor.direccion_real
                ? this.props.contraventor.direccion_real
                : {}
            }
          />
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsExpedientes: bindActionCreators(actionsExpedientes, dispatch),
  actionsContraventores: bindActionCreators(actionsContraventores, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(ModalSancion));
